import * as types from '../mutation-types'
import { API } from '../../api'
import { OTHER_COMMENT_DATA_MANAGER } from '../../data'

export default {
    namespaced: true,
    state: {
        gotOtherCommentList: false,
        otherCommentList: []
    },
    getters: {},
    mutations: {
        [types.COMMENT_OTHER_UPDATE_LIST_DATA_TITLE](state, newData) {
            // console.log('types.COMMENT_OTHER_UPDATE_LIST_DATA_TITLE-----', newData, state.otherCommentList)
            state.otherCommentList = OTHER_COMMENT_DATA_MANAGER.updateOtherCommentListDataTitle(state.otherCommentList, newData);
        },
        [types.COMMENT_OTHER_DELETE_LIST_DATA](state, pipanId) {
            // console.log('types.COMMENT_OTHER_DELETE_LIST_DATA-----', pipanId);
            state.otherCommentList = OTHER_COMMENT_DATA_MANAGER.deleteOtherCommentListData(state.otherCommentList, pipanId);
            AppFate.$store.state.detail.baziNumData.otherpipan = state.otherCommentList.length;
        }
    },
    actions: {
        getOtherPiPanList({ state }, detailId) {
            if(state.gotOtherCommentList) { return; }
            API.getOtherShareDataList({
                hid: detailId
            }, function (data) {
                console.log('拉取他人批盘列表::::::', detailId, data)
                state.gotOtherCommentList = true;
                state.otherCommentList = OTHER_COMMENT_DATA_MANAGER.getOtherCommentListByData(data);
                AppFate.$store.state.detail.baziNumData.otherpipan = state.otherCommentList.length;
            })
        },
        editOtherPiPanData({ commit }, pipanData) {
            API.editOtherShareData({
                id: pipanData.id,
                title: pipanData.title
            }, function(data){
                if(data.ret == 1) {
                    console.log('修改他人批盘成功-----', data)
                    commit(types.COMMENT_OTHER_UPDATE_LIST_DATA_TITLE, pipanData)
                }
            })
        },
        deleteOtherPiPanData({ commit }, pipanId) {
            API.deleteOtherShareData({
                id: pipanId
            }, function(data) {
                console.log('删除他人批盘成功-----', pipanId, data)
                commit(types.COMMENT_OTHER_DELETE_LIST_DATA, pipanId)
            })
        },
        resetData({ state }) {
            state.gotOtherCommentList = false;
            state.otherCommentList = [];
        }
    }
}